
$(document).ready(function() {
    if($('.wrus-macros-calculator').length){
        var adv = 0;
        $('.lds-ripple').hide();
		$('.calc-close').hide();
        $('.calc-advanced').hide();
        $('.calc-advanced').click(function() {  

            $('.calc-close').show(0);
            $('.calc-advanced').hide(0);
			$('.wrus-macros-calculator .calc-answer').fadeOut(500);
			$('.macro-advanced').delay(500).fadeIn(500);
            adv = 1;
        });
        $('.calc-close').click(function() { 
            $('.macro-advanced').fadeOut(500);
			$('.wrus-macros-calculator .calc-answer').delay(500).fadeIn(500);
            $('.calc-close').hide(0);
            $('.calc-advanced').show(0);
            adv = 0;
        });
        
        $('.wrus-macros-calculator input[name="height-system"]').click(function() {  
            var heightUnits = $(this).val();

            if (heightUnits == "meters") {
                $('.wrus-macros-calculator input[name="height-tens"]').attr("placeholder", "Meters");
                $('.wrus-macros-calculator input[name="height-units"]').attr("placeholder", "Centimeters");
                $('.wrus-macros-calculator input[name="height-tens"]').val("");
                $('.wrus-macros-calculator input[name="height-units"]').val("");
            }

            else if (heightUnits == "feet") {
                $('.wrus-macros-calculator input[name="height-tens"]').attr("placeholder", "Feet");
                $('.wrus-macros-calculator input[name="height-units"]').attr("placeholder", "Inches");
                $('.wrus-macros-calculator input[name="height-tens"]').val("");
                $('.wrus-macros-calculator input[name="height-units"]').val("");
            }
        });
        
        $('.wrus-macros-calculator input[name="weight-system"]').click(function() {  
            var weightUnits = $(this).val();

            if (weightUnits == "kilos") {
                $('.wrus-macros-calculator input[name="weight"]').attr("placeholder", "Kilograms");
                $('.wrus-macros-calculator input[name="weight"]').val("");
            }

            else if (weightUnits == "pounds") {
                $('.wrus-macros-calculator input[name="weight"]').attr("placeholder", "Pounds");
                $('.wrus-macros-calculator input[name="weight"]').val("");
            }
        });
        
        $('.wrus-macros-calculator input[name="goal"]').click(function() {
            
            var macroRatio = $(this).val();
            if (macroRatio == "weight-loss") {

                document.getElementById("carbratio").value = "40";
                document.getElementById("protonratio").value = "40";
                document.getElementById("fatratio").value = "20";
                
            } else if (macroRatio == "maintenance") {
                
                document.getElementById("carbratio").value = "40";
                document.getElementById("protonratio").value = "30";
                document.getElementById("fatratio").value = "30";
       
            } else if (macroRatio == "weight-gain") {
                
                document.getElementById("carbratio").value = "40";
                document.getElementById("protonratio").value = "30";
                document.getElementById("fatratio").value = "30";
        
            }   
        });
        
        
            
        $('.wrus-macros-calculator .calc-submit').click( function() {

            // $('.adv-calc-container').fadeOut();
			$('.calc').fadeOut('fast');
			

            var height = 0;
            var heightTens = parseInt($('.wrus-macros-calculator input[name="height-tens"]').val());
            var heightUnits= parseInt($('.wrus-macros-calculator input[name="height-units"]').val());
            var heightType = $('.wrus-macros-calculator input[name="height-system"]:checked').val();
            var weight = parseInt($('.wrus-macros-calculator input[name="weight"]').val());
            var weightType = $('.wrus-macros-calculator input[name="weight-system"]:checked').val();
            var calories = 0;
            var age = parseInt($('.wrus-macros-calculator input[name=age]').val());
            var sex = $('.wrus-macros-calculator input[name=sex]:checked').val();
            var job = $('.wrus-macros-calculator input[name=activity]:checked').val();
            var goal = $('.wrus-macros-calculator input[name=goal]:checked').val();
            var carbratio =  (parseInt($('.wrus-macros-calculator input[name=carbratio]').val())/100);  
            var protonratio =  (parseInt($('.wrus-macros-calculator input[name=protonratio]').val())/100);  
            var fatratio =  (parseInt($('.wrus-macros-calculator input[name=fatratio]').val())/100);  
            var carbratiocount =  parseInt($('.wrus-macros-calculator input[name=carbratio]').val());  
            var protonratiocount =  parseInt($('.wrus-macros-calculator input[name=protonratio]').val());  
            var fatratiocount =  parseInt($('.wrus-macros-calculator input[name=fatratio]').val());  
            var carbs = 0;
            var protons = 0;
            var fats = 0;
            var ratiocount = carbratiocount + protonratiocount  + fatratiocount;

            if (!(ratiocount == 100)) {
                $('.calc-rec').hide(0);
                $('.lds-ripple').fadeOut();
                $('.calc-container').fadeIn();
                $('.wrus-macros-calculator .calc-answer').show(0).html('<span style="color: #a30000;text-align: center;width: 100%;display: block;">Macro ratio must total 100.</span>');
            }
            else  if (isNaN(age) || isNaN(heightTens) || isNaN(weight) || isNaN(carbratio)  || isNaN(protonratio)  || isNaN(fatratio)) {
                $('.calc-rec').hide(0);
                $('.lds-ripple').fadeOut();
                $('.calc-container').fadeIn();
                $('.wrus-macros-calculator .calc-answer').show(0).html('<span style="color: #a30000;text-align: center;width: 100%;display: block;">Please enter values for all the fields.</span>');
            }
            
            else {
                if(isNaN(heightUnits)) {
                    heightUnits = 0;
                }

                if (heightType == "feet") {
                    height = ((heightTens * 30.48) + (heightUnits * 2.54));
                }   
                else {
                    height = (heightTens * 100) + heightUnits;
                }
                
                if (weightType == "pounds") {
                    weight = (weight * 0.453592);
                }

                if (sex == "M") {
                    calories = ((weight * 10) + (height * 6.25) - (age * 5) + 5);
                } 
                else {
                    calories = ((weight * 10) + (height * 6.25) - (age * 5) - 161);
                }
                
                
                switch (job) {
                    case "S":
                        calories = Math.round(calories * 1.2);
                        break;
                    case "L":
                        calories = Math.round(calories * 1.375);
                        break;
                    case "M":
                        calories = Math.round(calories * 1.550);
                        break;
                    case "V":
                        calories = Math.round(calories * 1.725);
                        break;
                    case "E":
                        calories = Math.round(calories * 1.9);
                        break;
                }
                
                switch (goal) {
                    case "weight-loss":

                        if (calories <= 2000) calories =  Math.round(0.9 * calories);
                        if (calories > 2000) calories =  Math.round(0.8 * calories);
                        ccarbs = Math.round(carbratio * calories);
                        cprotons = Math.round(protonratio * calories);
                        cfats = Math.round(fatratio * calories);
                        carbs = Math.round(carbratio * calories / 4);
                        protons = Math.round(protonratio * calories / 4);
                        fats = Math.round(fatratio * calories / 9);
                        ratio = "40% carbs / 40% protein / 20% fats"
                        var rec = "calc-rec-wl";
                        break;
                    case "maintenance":
                        ccarbs = Math.round(carbratio * calories);
                        cprotons = Math.round(protonratio * calories);
                        cfats = Math.round(fatratio * calories);
                        carbs = Math.round(carbratio * calories / 4);
                        protons = Math.round(protonratio * calories / 4);
                        fats = Math.round(fatratio * calories / 9);
                        var rec = "calc-rec-m";
                        ratio = "40% carbs / 30% protein / 30% fats"
                        break;
                    case "weight-gain":
                        calories += 500;
                        ccarbs = Math.round(carbratio * calories);
                        cprotons = Math.round(protonratio * calories);
                        cfats = Math.round(fatratio * calories);
                        carbs = Math.round(carbratio * calories / 4);
                        protons = Math.round(protonratio * calories / 4);
                        fats = Math.round(fatratio * calories / 9);
                        var rec = "calc-rec-wg";
                        ratio = "40% carbs / 30% protein / 30% fats"
                        break;
                }
                $('.calc-advanced').show();
                $('.calc-rec').hide(0);
				$(".calc-answer").hide(0);
				$('.macro-advanced').fadeOut(500);

					let templateHtml = '<div class="dialy-macros"><p>Daily Macros<br>';
					templateHtml += 'Total Calories: ' + calories + '</p>';
					templateHtml += '<div class="micons">';
					templateHtml += '<div class="icon-protein"></div>';
					templateHtml += '<span class="pt amount">' + protons + 'g</span>';
					templateHtml += '<span class="pt cals">' + cprotons + ' Cals</span>';
					templateHtml += '<span class="pt type">Protein</span>';
					templateHtml += '</div>';
					templateHtml += '<div class="micons">';
					templateHtml += '<div class="icon-carbs"></div>';	
					templateHtml += '<span class="ca amount">' + carbs + '</span>';
					templateHtml += '<span class="ca cals">' + ccarbs + '</span>';
					templateHtml += '<span class="ca type">Carbs</span>';
					templateHtml += '</div>';
					templateHtml += '<div class="micons">';
					templateHtml += '<div class="icon-fats"></div>';	
					templateHtml += '<span class="fa amount">' + fats + 'g</span>';
					templateHtml += '<span class="fa cals">' + cfats + ' Cals</span>';
					templateHtml += '<span class="fa type">Fats</span>';
					templateHtml += '</div>';	
					templateHtml += '</div>';

					console.log(templateHtml)

                    $('.wrus-macros-calculator .calc-answer').delay(500).fadeIn().html(templateHtml);
                
                $('#' + rec).fadeIn();
				$(".calc-answer").fadeIn('fast')
				$(".calc-close").hide(0)
				$(".calc-advanced").fadeIn(500)
                
            };
            
        });
    }

	/* End calcs */

});